import { CartLinesUpdateEvent, CartErrorEvent, StandardEvents } from '@shopify/events'

if (!window._customMeasurementScriptLoaded) {
  window._customMeasurementScriptLoaded = true

  var CM_XL_LIMITS = { shoulder: 16.5, bust: 39, waist: 34, hip: 43 }

  // Map of surcharge amount (INR) → Shopify variant ID
  var CM_SURCHARGE_VARIANTS = {
    500:  '45209915326517',
    1000: '45209915359285',
    1500: '45209915392053',
    2000: '45209915424821',
    2500: '45209915457589',
    3000: '45209915490357',
    3500: '45209915523125',
    4000: '45209915555893',
    5000: '45209915588661'
  }

  function cmSurchargeVariantId(amount) {
    if (!amount || amount <= 0) return null
    var tiers = Object.keys(CM_SURCHARGE_VARIANTS).map(Number).sort(function(a, b) { return a - b })
    if (CM_SURCHARGE_VARIANTS[amount]) return CM_SURCHARGE_VARIANTS[amount]
    var match = null
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i] <= amount) match = tiers[i]
    }
    return match ? CM_SURCHARGE_VARIANTS[match] : null
  }

  var CM_SURCHARGE_VARIANT_IDS = new Set(Object.values(CM_SURCHARGE_VARIANTS))
  var CM_GIFT_WRAP_VARIANT_ID  = '45043311050805'
  var CM_GIFT_CARD_PRODUCT_ID  = '7857685299253'

  var _cmSurchargeInCart   = false
  var _cmSurchargeInflight = false

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function cmGetSurchargeAmount() {
    var wrapper = document.querySelector('#custom-measurement-wrapper')
    var amount  = parseFloat(wrapper?.dataset.productSurcharge) || 0
    if (isNaN(amount) || amount <= 0) amount = 0
    return amount
  }

  function cmNeedsSurcharge() {
    var sh = parseFloat(document.getElementById('custom-shoulder')?.value) || 0
    var bu = parseFloat(document.getElementById('custom-bust')?.value)     || 0
    var wa = parseFloat(document.getElementById('custom-waist')?.value)    || 0
    var hi = parseFloat(document.getElementById('custom-hip')?.value)      || 0
    return (
      (sh > 0 && sh > CM_XL_LIMITS.shoulder) ||
      (bu > 0 && bu > CM_XL_LIMITS.bust)     ||
      (wa > 0 && wa > CM_XL_LIMITS.waist)    ||
      (hi > 0 && hi > CM_XL_LIMITS.hi)
    )
  }

  function cmUpdateSurchargeNotice() {
    var notice = document.getElementById('cm-surcharge-notice')
    var needs  = cmNeedsSurcharge()
    var amt    = cmGetSurchargeAmount()
    if (notice) {
      notice.style.display = (needs && amt > 0) ? 'block' : 'none'
      var priceEl = notice.querySelector('.cm-surcharge-price')
      if (priceEl && amt > 0) priceEl.lastChild.textContent = 'Extended size surcharge · ₹' + amt.toLocaleString('en-IN')
    }
    var hiddenField = document.getElementById('custom-surcharge-notice')
    if (hiddenField) {
      hiddenField.value = (needs && amt > 0) ? '₹' + amt.toLocaleString('en-IN') + ' per piece' : ''
    }
  }

  function cmIsCustomSizeSelected() {
    var wrappers = document.querySelectorAll('#custom-measurement-wrapper')
    for (var i = 0; i < wrappers.length; i++) {
      var wrapper    = wrappers[i]
      var scope      = wrapper.closest('.product-details') || wrapper.closest('dialog') || wrapper.closest('form')?.parentElement || document
      var sizeLegend = [...scope.querySelectorAll('fieldset legend')].find(function(l) {
        return l.textContent.trim().toLowerCase().startsWith('size')
      })
      var checked = sizeLegend?.closest('fieldset')?.querySelector('input[type="radio"]:checked')
      if (checked && checked.value.trim().toLowerCase().includes('custom')) return true
    }
    return false
  }

  function cmIsFiller(item) {
    return (
      CM_SURCHARGE_VARIANT_IDS.has(String(item.variant_id)) ||
      String(item.variant_id) === CM_GIFT_WRAP_VARIANT_ID  ||
      String(item.product_id) === CM_GIFT_CARD_PRODUCT_ID
    )
  }

  // ─── Section IDs ────────────────────────────────────────────────────────────

  function cmGetSectionsToUpdate() {
    var ids = new Set()
    document.querySelectorAll('cart-items-component').forEach(function(el) {
      if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId)
    })
    return Array.from(ids)
  }

  // ─── Cart request helper ─────────────────────────────────────────────────────
  // Always includes sections so the final response carries full HTML for morphing.

  function cmCartRequest(url, body) {
    var sections = cmGetSectionsToUpdate()
    var fullBody = Object.assign({}, body, {
      sections:      sections.join(','),
      sections_url:  window.location.pathname
    })
    return fetch(url, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(fullBody)
    }).then(function(r) { return r.json() })
  }

  // ─── Announce cart change ────────────────────────────────────────────────────
  /**
   * Fires a CartLinesUpdateEvent and resolves it so CartItemsComponent
   * can morph the section with the fresh HTML from `lastResponse.sections`.
   *
   * KEY FIX: we pass `lastResponse.sections` (from the final /cart/change.js
   * or /cart/add.js call that included `sections` in its body) into the
   * promise resolution. CartItemsComponent#handleCartUpdate reads
   * `detail.sections[sectionId]` and morphs the DOM — that's what updates
   * the displayed total.
   *
   * If `lastResponse` has no `.sections` (shouldn't happen with cmCartRequest)
   * we fall back to a fresh /cart.js fetch so the count is at least correct.
   */
  function cmAnnounceCartChange(lastResponse) {
    var deferred = CartLinesUpdateEvent.createPromise()

    var event = new CartLinesUpdateEvent({
      action:  'update',
      context: 'cart',
      lines:   [],
      promise: deferred.promise
    })
    event.cmSource = 'cm-surcharge' // prevent our own listener re-triggering
    document.dispatchEvent(event)

    // Hard error from Shopify
    if (lastResponse && (lastResponse.status || lastResponse.errors)) {
      var message = lastResponse.description || lastResponse.errors || 'Cart update failed'
      var err     = new Error(message)
      deferred.reject(err)
      document.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID' }))
      return Promise.reject(err)
    }

    // If the last mutation response already has sections HTML, use it directly.
    // This is the fast path and the one that delivers the updated total to the
    // CartItemsComponent morph without an extra round-trip.
    if (lastResponse && lastResponse.sections) {
      return fetch('/cart.js')
        .then(function(r) { return r.json() })
        .then(function(cart) {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              sections:  lastResponse.sections, // ← full HTML; CartItemsComponent morphs from this
              items:     cart.items,
              itemCount: cart.item_count,
              source:    'cm-surcharge',
              didError:  false
            }
          })
          return cart
        })
        .catch(function(error) {
          deferred.reject(error)
          document.dispatchEvent(
            new CartErrorEvent({ error: (error && error.message) || 'Cart update failed', code: 'SERVICE_UNAVAILABLE' })
          )
          throw error
        })
    }

    // Fallback: no sections on the response — fetch cart state + re-render sections.
    // (cmCartRequest always attaches sections, so this path is a safety net only.)
    return fetch('/cart.js')
      .then(function(r) { return r.json() })
      .then(function(cart) {
        // Fetch the section HTML separately so the morph still works.
        var sections = cmGetSectionsToUpdate()
        if (sections.length === 0) {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: { items: cart.items, itemCount: cart.item_count, source: 'cm-surcharge', didError: false }
          })
          return cart
        }

        var params = new URLSearchParams({
          sections:     sections.join(','),
          sections_url: window.location.pathname
        })
        return fetch('/cart?' + params.toString())
          .then(function(r) { return r.json() })
          .then(function(sectionsData) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: {
                sections:  sectionsData.sections || sectionsData,
                items:     cart.items,
                itemCount: cart.item_count,
                source:    'cm-surcharge',
                didError:  false
              }
            })
            return cart
          })
      })
      .catch(function(error) {
        deferred.reject(error)
        document.dispatchEvent(
          new CartErrorEvent({ error: (error && error.message) || 'Cart update failed', code: 'SERVICE_UNAVAILABLE' })
        )
        throw error
      })
  }

  // ─── Auto-remove orphaned surcharges ────────────────────────────────────────

  function cmCheckAndAutoRemoveSurcharge(cart) {
    var surchargeItems = cart.items.filter(function(i) {
      return CM_SURCHARGE_VARIANT_IDS.has(String(i.variant_id))
    })
    if (surchargeItems.length === 0) return

    var hasExtendedItem = cart.items.some(function(i) {
      return !cmIsFiller(i) && i.properties && i.properties['_extended_size'] === 'true'
    })
    if (hasExtendedItem) return

    if (_cmSurchargeInflight) return
    _cmSurchargeInflight = true

    var chain        = Promise.resolve()
    var lastResponse = null
    surchargeItems.forEach(function(item) {
      chain = chain.then(function() {
        return cmCartRequest('/cart/change.js', { id: item.key, quantity: 0 }).then(function(resp) {
          lastResponse = resp
          return resp
        })
      })
    })

    chain
      .then(function() {
        _cmSurchargeInCart   = false
        _cmSurchargeInflight = false
        return cmAnnounceCartChange(lastResponse)
      })
      .catch(function() { _cmSurchargeInflight = false })
  }

  // ─── Core sync ──────────────────────────────────────────────────────────────
  /**
   * Reads cart state, computes which surcharge variant+quantity is needed per
   * extended-size line item, then adds/updates/removes surcharge items so the
   * cart total reflects the correct amount.
   *
   * Called after every add-to-cart that involves custom measurements, after
   * quantity changes, and when switching away from "Custom" size.
   */
  function cmSyncSurcharge() {
    if (_cmSurchargeInflight) return
    _cmSurchargeInflight = true

    fetch('/cart.js')
      .then(function(r) { return r.json() })
      .then(function(cart) {

        // Build a map of { variantId → requiredQty } based on extended items
        var required = {}
        cart.items.forEach(function(i) {
          if (!i.properties || i.properties['_extended_size'] !== 'true') return
          var prop   = i.properties['Extended size surcharge'] || ''
          var amount = parseFloat(prop.replace(/[^0-9.]/g, ''))
          if (isNaN(amount) || amount <= 0) amount = cmGetSurchargeAmount()
          var vid = cmSurchargeVariantId(amount)
          if (!vid) return
          required[vid] = (required[vid] || 0) + i.quantity
        })

        // Map of currently present surcharge items in cart
        var existing = {}
        cart.items.forEach(function(i) {
          if (CM_SURCHARGE_VARIANT_IDS.has(String(i.variant_id))) {
            existing[String(i.variant_id)] = i
          }
        })

        var allIds = new Set([...Object.keys(required), ...Object.keys(existing)])

        if (allIds.size === 0) {
          _cmSurchargeInCart   = false
          _cmSurchargeInflight = false
          return
        }

        var chain        = Promise.resolve()
        var lastResponse = null

        allIds.forEach(function(vid) {
          var needQty    = required[vid] || 0
          var cartItem   = existing[vid]
          var currentQty = cartItem ? cartItem.quantity : 0

          if (needQty === currentQty) return // already correct

          chain = chain.then(function() {
            var req
            if (needQty === 0) {
              // Remove
              req = cmCartRequest('/cart/change.js', { id: cartItem.key, quantity: 0 })
            } else if (cartItem) {
              // Update quantity
              req = cmCartRequest('/cart/change.js', { id: cartItem.key, quantity: needQty })
            } else {
              // Add new surcharge line
              req = cmCartRequest('/cart/add.js', {
                id:         vid,
                quantity:   needQty,
                properties: { '_type': 'Extended size surcharge', '_hidden': '1' }
              })
            }
            return req.then(function(resp) {
              lastResponse = resp
              return resp
            })
          })
        })

        return chain.then(function() {
          _cmSurchargeInCart   = Object.keys(required).length > 0
          _cmSurchargeInflight = false
          // Pass the last response (which carries sections HTML) to announce,
          // so CartItemsComponent morphs with the correct updated total.
          return cmAnnounceCartChange(lastResponse)
        })
        .catch(function() { _cmSurchargeInflight = false })
      })
      .catch(function() { _cmSurchargeInflight = false })
  }

  function cmAddSurcharge()      { cmSyncSurcharge() }
  function cmRemoveSurcharge()   { cmSyncSurcharge() }

  // ─── UI: toggle custom measurement fields ───────────────────────────────────

  function toggleCustomMeasurement() {
    document.querySelectorAll('#custom-measurement-wrapper').forEach(function(wrapper) {
      var scope      = wrapper.closest('.product-details') || wrapper.closest('dialog') || wrapper.closest('form')?.parentElement || document
      var sizeLegend = [...scope.querySelectorAll('fieldset legend')].find(function(l) {
        return l.textContent.trim().toLowerCase().startsWith('size')
      })
      var checked  = sizeLegend?.closest('fieldset')?.querySelector('input[type="radio"]:checked')
      var isCustom = checked?.value.trim().toLowerCase().includes('custom') ?? false

      wrapper.style.display = isCustom ? 'block' : 'none'
      wrapper.querySelectorAll('input[type="number"]').forEach(function(input) {
        input.required = isCustom
        if (!isCustom) { input.value = ''; input.setCustomValidity('') }
      })

      if (!isCustom && _cmSurchargeInCart) {
        fetch('/cart.js').then(function(r) { return r.json() }).then(function(cart) {
          var extendedCount = cart.items.reduce(function(sum, i) {
            return sum + (i.properties && i.properties['_extended_size'] === 'true' ? i.quantity : 0)
          }, 0)
          if (extendedCount === 0) cmRemoveSurcharge()
        })
      }

      cmUpdateSurchargeNotice()
    })
  }

  function initializeCustomMeasurement() {
    document.querySelectorAll('#custom-measurement-wrapper').forEach(function(wrapper) {
      if (wrapper._cmInit) return
      wrapper._cmInit = true

      var noteField = wrapper.querySelector('#custom-note')
      var charCount = wrapper.querySelector('#char-count')

      wrapper.querySelectorAll('input[type="number"]').forEach(function(input) {
        input.addEventListener('input', function() {
          var regex = /^\d{0,2}(\.\d{0,1})?$/
          if (!regex.test(this.value)) this.value = this.value.slice(0, -1)
          this.setCustomValidity(parseFloat(this.value) === 0 ? 'Value must be greater than 0' : '')
          cmUpdateSurchargeNotice()
        })
      })

      if (noteField && charCount) {
        noteField.addEventListener('input', function() {
          charCount.textContent  = noteField.value.length + ' / 100'
          noteField.style.height = 'auto'
          noteField.style.height = noteField.scrollHeight + 'px'
        })
      }
    })

    toggleCustomMeasurement()
  }

  document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"]')) toggleCustomMeasurement()
  })
  document.addEventListener('variant:change', toggleCustomMeasurement)

  document.addEventListener('DOMContentLoaded', initializeCustomMeasurement)
  if (document.readyState !== 'loading') initializeCustomMeasurement()

  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.querySelector?.('#custom-measurement-wrapper')) {
          node.querySelector('#custom-measurement-wrapper')._cmInit = false
          initializeCustomMeasurement()
        }
      })
    })
  }).observe(document.body, { childList: true, subtree: true })

  // ─── Legacy cart events ──────────────────────────────────────────────────────

  ;['cart:refresh', 'cart:updated', 'cart:change', 'cart:update'].forEach(function(evtName) {
    document.addEventListener(evtName, function(e) {
      if (e.detail && e.detail.sourceId === 'cm-surcharge') return
      fetch('/cart.js').then(function(r) { return r.json() }).then(function(cart) {
        if (!_cmSurchargeInflight) {
          _cmSurchargeInCart = !!cart.items.find(function(i) {
            return CM_SURCHARGE_VARIANT_IDS.has(String(i.variant_id))
          })
        }
        cmCheckAndAutoRemoveSurcharge(cart)
      })
    })
  })

  // ─── Modern CartLinesUpdateEvent listener ────────────────────────────────────

  document.addEventListener(StandardEvents.cartLinesUpdate, function(event) {
    if (event.cmSource === 'cm-surcharge') return // ignore our own, avoid loop
    if (!event.promise) return
    event.promise
      .then(function() {
        fetch('/cart.js').then(function(r) { return r.json() }).then(function(cart) {
          if (!_cmSurchargeInflight) {
            _cmSurchargeInCart = !!cart.items.find(function(i) {
              return CM_SURCHARGE_VARIANT_IDS.has(String(i.variant_id))
            })
          }
          cmCheckAndAutoRemoveSurcharge(cart)
        })
      })
      .catch(function() {})
  })

  // ─── Fetch patch: intercept add-to-cart & change ────────────────────────────

  if (!window._customMeasurementFetchPatched) {
    window._customMeasurementFetchPatched = true
    var originalFetch = window.fetch

    window.fetch = async function(...args) {
      var [resource, config] = args
      var url = typeof resource === 'string' ? resource : resource?.url

      // ── /cart/add.js interception ──────────────────────────────────────────
      if (url?.includes('/cart/add') && config?.method?.toUpperCase() === 'POST') {
        try {
          var bodyCheck = typeof config.body === 'string' ? JSON.parse(config.body) : null
          if (bodyCheck) {
            var addedId = String(bodyCheck.id)
            // Let our own surcharge / gift-wrap / gift-card adds through unmodified
            if (
              CM_SURCHARGE_VARIANT_IDS.has(addedId)        ||
              addedId === CM_GIFT_WRAP_VARIANT_ID           ||
              addedId === String(CM_GIFT_CARD_PRODUCT_ID)
            ) {
              return originalFetch.apply(this, [resource, config])
            }
          }
        } catch(e) {}

        var isCustom = cmIsCustomSizeSelected()
        if (!isCustom) return originalFetch.apply(this, [resource, config])

        var wrapper = [...document.querySelectorAll('#custom-measurement-wrapper')]
          .find(function(w) { return w.style.display === 'block' })
        if (!wrapper) return originalFetch.apply(this, [resource, config])

        // Validate measurement inputs
        var inputs = wrapper.querySelectorAll('input[type="number"]')
        var valid  = true
        inputs.forEach(function(input) {
          if (!input.value || parseFloat(input.value) <= 0) {
            input.setCustomValidity('Please enter a valid measurement')
            input.reportValidity()
            valid = false
          }
        })
        if (!valid) return Promise.reject('Invalid measurements')

        // Build properties object from measurement inputs
        var properties = {}
        inputs.forEach(function(input) {
          if (input.name) {
            properties[input.name.replace('properties[', '').replace(']', '')] = input.value
          }
        })
        var note = wrapper.querySelector('#custom-note')
        if (note?.value.trim()) properties['Note'] = note.value.trim()

        if (cmNeedsSurcharge()) {
          var surchargeAmt = cmGetSurchargeAmount()
          properties['_extended_size'] = 'true'
          if (surchargeAmt > 0) {
            properties['Extended size surcharge'] = '₹' + surchargeAmt.toLocaleString('en-IN') + ' per piece'
          }
        }

        // Inject properties into request body
        if (config.body instanceof FormData) {
          Object.entries(properties).forEach(function([k, v]) {
            config.body.append('properties[' + k + ']', v)
          })
        } else if (typeof config.body === 'string') {
          try {
            var body    = JSON.parse(config.body)
            body.properties = Object.assign({}, body.properties || {}, properties)
            config.body = JSON.stringify(body)
          } catch(e) {
            console.error('Measurement inject failed', e)
          }
        }

        if (cmNeedsSurcharge()) {
          // ── KEY FIX ──────────────────────────────────────────────────────────
          // Wait for the main item to be committed to the cart before syncing
          // the surcharge, otherwise /cart.js won't yet include the new item and
          // cmSyncSurcharge computes required=0 and never adds the surcharge.
          var mainResult = await originalFetch.apply(this, [resource, config])

          // Clone so the caller's .json() still works after we consume it here
          var cloned = mainResult.clone()
          try {
            var addedItem = await cloned.json()
            // Only sync if the item was actually saved with _extended_size
            if (addedItem && addedItem.properties && addedItem.properties['_extended_size'] === 'true') {
              cmSyncSurcharge()
            } else {
              // Item added but flag missing — still try after a brief delay
              setTimeout(cmSyncSurcharge, 250)
            }
          } catch(e) {
            // JSON parse failed (shouldn't happen); fall back to delayed sync
            setTimeout(cmSyncSurcharge, 250)
          }

          return mainResult
        } else {
          var result = await originalFetch.apply(this, [resource, config])
          // If there are no extended items left, remove any stale surcharge
          fetch('/cart.js').then(function(r) { return r.json() }).then(function(cart) {
            var extendedCount = cart.items.reduce(function(sum, i) {
              return sum + (i.properties && i.properties['_extended_size'] === 'true' ? i.quantity : 0)
            }, 0)
            if (extendedCount === 0 && _cmSurchargeInCart) cmSyncSurcharge()
          })
          return result
        }
      }

      // ── /cart/change.js interception ───────────────────────────────────────
      if (url?.includes('/cart/change') && config?.method?.toUpperCase() === 'POST') {
        try {
          var bodyCheck2 = typeof config.body === 'string' ? JSON.parse(config.body) : null
          if (bodyCheck2) {
            var isSurchargeChange = bodyCheck2.id &&
              [...CM_SURCHARGE_VARIANT_IDS].some(function(id) {
                return bodyCheck2.id.toString().startsWith(id)
              })
            if (!isSurchargeChange) {
              var result2 = await originalFetch.apply(this, [resource, config])
              setTimeout(cmSyncSurcharge, 100)
              return result2
            }
          }
        } catch(e) {}
      }

      return originalFetch.apply(this, [resource, config])
    }
  }

  // ─── Boot: check cart state on load ─────────────────────────────────────────

  fetch('/cart.js').then(function(r) { return r.json() }).then(function(cart) {
    _cmSurchargeInCart = !!cart.items.find(function(i) {
      return CM_SURCHARGE_VARIANT_IDS.has(String(i.variant_id))
    })
    cmCheckAndAutoRemoveSurcharge(cart)
  })

}